<div class="wrapper">
  <aside *ngIf="navigationBar" class="sidebar" style="height:600px;">
    <div class="card-columns" style="column-gap: 0.25rem; row-gap: 0.25rem;">
      <app-signal-map-list-items [signalsList]="signalsList" (signalResponse)="onCardClick($event)"></app-signal-map-list-items>
    </div>
  </aside>
  <main #map class="map-container" style="height:unset !important"></main>
</div>
